<template>
    <v-content style="background-color: #f9f9f9;">
      <div v-if="dispType === 0 || dispType === 1">
        <div v-if="resultStatus === 0 || resultStatus === 1" class="point text-center">
          <div style="height: 12px"></div>
          <span class="headder">こちらの画面をスタッフに提示して下さい</span>
          <div style="height: 15px"></div>
          <div v-if="resultStatus === 0">
            <span class=""> ポイントカード番号</span>
            <div></div>
            <barcode :options="{ format: this.barcode_format, displayValue: true, text: 'A'+this.barcode+'A' }"
              :value="barcode"></barcode>
            <div style="height: 35px"></div>
          </div>
          <span class="headder "
            style="line-height:30px;height:30px;width:100%;background-color: #DEDEDF">&nbsp;</span>
          <div style="height: 25px"></div>
          <img @click.stop="getCardNumber()" src="@/assets/reboot.svg">
          <div style="height: 12px"></div>
          <div>
            <button class="maincolor-bg btn btn-info" type="button" @click.stop="gotoCamera()">ポイントIDスキャン</button>
          </div>
          <div style="margin-top: 10px;padding:0px 10px;text-align:left;">
            ・ご来店の際に必ずレジにてご提示ください。ご提示のない場合はカードの特典の対象になりません。(会員価格やポイント付与ができかねます。)<br>
            ・登録ポイントが500ポイントになりましたら、『500円のお買物券』が発行されます。<br>
            ・ポイント度数はご利用の都度レシートに印字されますのでご確認下さい。<br>
            ・一部ポイントが加算できない場合がございます。<br>
            ・このカードはオザキスポーツ全店でご使用になれます。<br>
            ・アプリのポイントカードをご利用のお客様で、旧カードをお持ちの方は両方ご利用いただけます。
          </div>
        </div>
        <div v-if="resultStatus == 2">
          <div style="margin-top: 150px; text-align: center;">
            <button class="maincolor-bg btn btn-info" type="button" @click.stop="gotoCamera()">ポイントIDスキャン</button>
          </div>
        </div>
      </div>
      <v-overlay :value="loading">
        <v-progress-circular :size="80" :width="2" class="" indeterminate></v-progress-circular>
      </v-overlay>
    </v-content>
  </template>
    
  <script>
  export default {
    data: () => ({
      init: [],
      point: { point: '', ext_point_barcode: "" },
      pointResultCode: -1,
      barcode: null,
      loading: false,
      resultStatus: 0
    }),
    created() {
      this.init = this.storageGet("*")
    },
    async mounted() {
      this.loading = true
      try {
        await this.getCardNumber()
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    computed: {
      dispType() {
        return this.pointResultCode
      },
      barcode_format() {
        let barcodeType = ""
        switch (this.init.external_point_barcode_type) {
          case 1:
            barcodeType = 'EAN13'
            break;
          case 2:
            barcodeType = 'CODE128'
            break;
          case 3:
            barcodeType = 'CODABAR'
            break;
        }
        return barcodeType
        // CODE128 :CODE128
        // EAN / UPC :EAN13 UPC EAN8 EAN5 EAN2
        // CODE39 :CODE39
        // ITF-14 :ITF14
        // MSI :MSI MSI10 MSI11 MSI1010 MSI1110
        // Pharmacode :pharmacode
        // Codabar :codabar, NW-7
      },
    },
    methods: {
      getCardNumber() {
        this.loading = true
        setTimeout(async () => {
          try {
            let req = {
              params: {
                'shop_id': this.init.sid,
                'user_id': this.init.user_id,
              }
            }
  
            let res = await this.apiCall('/point-external/number', req);
            this.resultStatus = res.result_status;
            this.pointResultCode = 0;
            if (!res) {
              this.loading = false;
              
              this.resultStatus = 1;
              return false
            }
            switch (res.result_status) {
              case 0:
                this.barcode = res.ext_point_barcode;
                break;
              case 1:
                this.callDialog('エラー', res.message, 1);
                break;
              case 2:
                this.barcode = null;
                break;
            }
          } catch (e) {
            this.loading = false
            this.callDialog('接続エラー', '一時的なエラーです。ネットワークの状態が不安定です。再度お試しください', 3);
          }
          this.loading = false
        }, 100)
      },
      gotoCamera() {
        var tonative_req = {
          'destination': 'barcodeActivity',
          'feature_id': 'barcode',
          'screen_id': 'barcode_scan',
          'transition_type': 2,
          'barcode_format': this.init.external_point_barcode_type,  //3 DBのexternal_point_barcode_typeの値 3:NW-7(CODABAR)
          'back_url': this.getDomain() + 'sp/barcode-manager', 
          'input_url': this.getDomain() + 'sp/barcode-manager/regist', 
        };
        if (!(this.screenTransition(tonative_req))) {
          this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
        }
      },
    },
  };
  </script>
    
  <style scoped>
  .headder {
    font-weight: bold;
  }
  
  img {
    padding-left: 250px;
  }
  
  .bigpoint3 {
    font-size: 60px;
    font-weight: bold;
    font-family: "Oswald", sans-serif !important;
    line-height: 1;
  }
  
  .spanmessage {
    font-size: 12px;
  }
  
  .smallpoint {
    font-size: 24px;
    font-weight: bold;
    font-family: "Oswald", sans-serif !important;
    color: #333333;
  }
  
  .point {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    align-items: center;
    justify-content: center;
  }
  
  .btn-info {
    border-radius: 25px;
    padding: 6px 20px;
    color: #FFF;
    background: #009c77;
  }
  .v-application--wrap {
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }
  </style>
    